import { BaseInput, BaseStaticSelect } from "@/components/input/CustomInputs";
import { handleFormChange } from "@/utils/formChange";
import { formInterface } from "@/interface/dataInterface";
import AutocompleteLocation from "@/taxi-dispatch/dispatch/components/AutocompleteLocation";
import { FC, useRef } from "react";
import { currencies } from "@/utils/variables";
import { useUserContext } from "@/context/UserContext";

interface Props extends formInterface {
  getLocation: (location: any) => void;
}

const TourForm: FC<Props> = ({ getLocation, formProp, setFormProp }) => {
  const { decodedToken } = useUserContext();
  const user_role = decodedToken?.permissions.user_role;
  const inputRef = useRef<HTMLInputElement | null>(null);

  return (
    <div className="grid sm:grid-cols-2 gap-4">
      <BaseInput
        id="name"
        label="Name"
        value={formProp.name}
        setProp={setFormProp}
        disabled={user_role !== "owner"}
      />
      <BaseInput
        id="duration"
        label="Duration"
        value={formProp.duration}
        setProp={setFormProp}
        disabled={user_role !== "owner"}
      />
      <BaseInput
        id="tour_type"
        label="Tour type"
        value={formProp.tour_type}
        setProp={setFormProp}
        disabled={user_role !== "owner"}
      />
      <BaseInput
        id="max_group_size"
        label="Max group size"
        value={formProp.max_group_size}
        setProp={setFormProp}
        required={false}
        disabled={decodedToken?.permissions.user_role !== "owner"}
      />
      <div className="w-full">
        <AutocompleteLocation
          location={getLocation}
          placeholder="Dropoff location"
          inputRef={inputRef}
          disabled={user_role !== "owner"}
        />
      </div>
      <BaseStaticSelect
        id="currency"
        label="Currency"
        value={formProp.currency}
        setValue={setFormProp}
        data={currencies}
        disabled={user_role !== "owner"}
      />
    </div>
  );
};

export default TourForm;
